import axios from "axios";

export interface WordPressPost {
    id: number;
    title: {
        rendered: string;
    };
    excerpt: {
        rendered: string;
    };
    featured_media: number;
    _embedded?: {
        "wp:featuredmedia"?: Array<{
            source_url: string;
            alt_text: string;
        }>;
    };
    link: string;
}

export const wordpressService = {
    getLatestPosts: async (limit: number = 10): Promise<WordPressPost[]> => {
        const response = await axios.get<WordPressPost[]>(
            "https://www.eidohealthcare.com/wp-json/wp/v2/posts",
            {
                params: {
                    per_page: limit,
                },
            },
        );
        return response.data;
    },
};
